import React from 'react';
import './style.css';
import logo from '../../logo.png';

const UserCard = ({ name, phone, photo, file }) => {
    return (<div className="user-card-container">
        <h1>Проверка подлинности подписи</h1>
        <img src={logo} className="App-logo" alt="logo" />
        <div className="user-signed">ПОДПИСЬ ПРИНАДЛЕЖИТ</div>
        <div className="user-card">
            <img src={photo} alt={`${name}'s profile`} className="user-photo" />
            <div className="user-info">
                <h2 className="user-name">{name}</h2>
                <p className="user-phone">{phone}</p>
            </div>
        </div>
        <a href={""} className="user-link">Перейти в профиль владельца подписи</a>
        <a href={file} className="user-link">Скачать оригинал документа</a>
    </div>

    );
};

export default UserCard;